import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Formik, Form, FormikHelpers as FormikActions, FormikErrors, FormikValues } from 'formik';
import { cloneDeep } from 'lodash';

import { FormGroupBootstrap, ErrorBlockGeneric, ConfirmedButton } from '../common-components'
import { MEDAGLIE_SENIGALLIA, CLASSI, displayPersona, displayStage, YESNO, EDITABLE_STATES, MESSAGGI_STATO_ISCRIZIONE } from '../globals'
import { post_new_iscrizione } from '../api'
import store from '../store'
import { add_toast_action } from '../actions'
import { DRFErrorMsg, handle_drf_form_error, nice_date } from 'django-rest-react';
import { Allergia, DomandaIscrizione, Persona, Stage } from '../api/auto-types';
import { displayDisplayable, sentry_log } from '../utils';
import { DOMANDAISCRIZIONE_STATO_AMMISSIONE } from '../globals/auto-enums';
import { put_accetta_posto_accetta_posto, put_consegna_scritto_consegna_scritto } from '../api/auto-apis';
import { QuizPreTest } from '../components';


type FormValuesBase = Parameters<typeof post_new_iscrizione>[0]
export interface FormValues extends FormValuesBase {
  accettazione_posto?: "y" | "n"
  soluzioni_test_ammissione?: File,
  allergie?: number[]
  punteggio?: number
}


interface IProps {
  stages: Stage[],
  persone: Persona[],
  allergie: Allergia[],
  old?: DomandaIscrizione,
}


export const range = (end: number) => Array.from(Array(end).keys())

interface Enriched {
  obj: FormValues["pretest"]["risposte"][0]
  origidx: number
}

const pretestErrorParsingFactory = (values: FormValues) => (err_: DRFErrorMsg) => {
  let err = cloneDeep(err_) as FormikErrors<FormValues>

  if (!err.hasOwnProperty("pretest")) return err
  if (!err.pretest.hasOwnProperty("risposte")) return err;

  const idxmap = values.pretest.risposte
    .map((obj, origidx) => {
      return {
        obj, origidx
      } as Enriched
    })
    // @ts-ignore
    .filter(v => !v.obj.skip)
    .map(v => v.origidx)


  const enriched_idxmap = idxmap.map((val: number, idx) => [val, idx])
  const idxmap_inverse = range(values.pretest.risposte.length).map(i => enriched_idxmap.find(obj => obj[0] == i)?.at(1))

  // @ts-ignore
  err.pretest.risposte = values.pretest.risposte.map((_, idx) => {
    const realidx = idxmap_inverse[idx]
    console.log("Doing idx", idx, realidx)
    if (realidx !== undefined) {
      return err.pretest.risposte[realidx]
    } else {
      return {}
    }
  })

  return err;
}

const IscrizioneStageForm = (props: IProps) => {
  const [error, setError] = useState(null);
  const [showPretest, setShowPretest] = useState(false);

  const { old, stages, persone } = props;

  let ieri = new Date();
  ieri.setDate(ieri.getDate() - 1);
  const stages_validi = stages.filter(s => (new Date(s.fine_iscrizioni)) > ieri)
  const stage = stages_validi.length > 0 ? stages_validi[0] : undefined;
  const stage_id = stage?.id;
  let initial: FormValues = {
    stage: stage_id,
  } as unknown as FormValues;

  const first_step = !old;
  const deve_consegnare_soluzioni = old?.stato_ammissione === "ppt";
  const ammesso = ["ppo", "pa", "pr"].includes(old?.stato_ammissione);
  const deve_accettare_posto = old?.stato_ammissione === "ppo";


  if (!!old) {
    // @ts-ignore
    initial = old;
    if (old.stato_ammissione === "pa") {
      initial.accettazione_posto = "y"
    } else if (old.stato_ammissione === "pr") {
      initial.accettazione_posto = "n"
    }
  }

  const show_buttons = !!old ? EDITABLE_STATES.includes(old.stato_ammissione) : true;
  return (
    <div className="my-4">
      {!old && <p>Confermeremo via email la registrazione, è <b>importante</b> controllare la casella di posta per essere sicuri che la richiesta di iscrizione sia arrivata a destinazione.</p>}

      {!!old && !!old.stato_ammissione && <h4>{"Stato dell'iscrizione: "}{displayDisplayable(old.stato_ammissione, DOMANDAISCRIZIONE_STATO_AMMISSIONE)}</h4>}
      {!!old && !!old.stato_ammissione &&
        <>
          <h5 className="text-info">Dettagli: {MESSAGGI_STATO_ISCRIZIONE[old.stato_ammissione]}</h5>
          <br />
          <br />
        </>
      }

      <Formik
        initialValues={initial}
        validate={(values) => {
          if (!values?.pretest?.risposte || values?.pretest?.risposte?.length === 0) {
            const msg = "Non puoi consegnare il pretest in bianco. Apri il pretest con il bottone verde sulla sinistra"
            setError(msg);
            return { __non_esiste: msg }
          }
          return {}
        }}
        onSubmit={(values: FormValues, actions: FormikActions<FormValues>) => {
          let func = () => new Promise(resolve => {
            sentry_log(new Error(`Stato ammissione inconsistente: ${old.stato_ammissione}, richiesta ${old.id}`))
            store.dispatch(add_toast_action({
              title: "Stato inconsistente",
              message: "Prova a ricaricare la pagina",
            }))
            resolve("ok")
          })

          let extraParsing = (val: DRFErrorMsg) => val as FormikErrors<FormValues>;
          if (!old) {
            const newvalues = cloneDeep(values);
            // @ts-ignore
            newvalues.pretest.risposte = newvalues.pretest.risposte.filter(ans => !ans.skip);

            func = () => post_new_iscrizione(newvalues)
            extraParsing = pretestErrorParsingFactory(values);
          } else if (old.stato_ammissione === "ppt") {
            func = () => put_consegna_scritto_consegna_scritto(old.id, {
              soluzioni_test_ammissione: values.soluzioni_test_ammissione,
            })
          } else if (old.stato_ammissione === "ppo") {
            func = () => put_accetta_posto_accetta_posto(old.id, {
              accettazione_posto: values.accettazione_posto,
              allergie: values.allergie,
            })
          }

          func()
            .then(() => window.location.reload())
            .catch(error => {
              handle_drf_form_error(error, actions, setError, extraParsing)
              const msg = error.message;
              if (!!msg?.pretest?.non_field_errors) {
                setError(msg.pretest.non_field_errors)
              }
            })
            .finally(() => actions.setSubmitting(false))
        }}
        enableReinitialize={true}
      >
        {({ isSubmitting, values, handleSubmit, handleReset }) => {
          const selected_stage = stages.find(s => s.id === values.stage)
          return (
            <>
              <Form className="form needs-validation">
                {deve_consegnare_soluzioni &&
                  <FormGroupBootstrap
                    name="soluzioni_test_ammissione"
                    type="file"
                    help_text="Puoi consegnare delle soluzioni scritte a mano o delle soluzioni scritte in LaTeX/word. Vanno consegnate in formato PDF."
                  />
                }
                {ammesso &&
                  <>
                    <FormGroupBootstrap
                      name="accettazione_posto"
                      type="select"
                      choices={YESNO}
                      disabled={!deve_accettare_posto}
                    />
                    {values.accettazione_posto == "y" &&
                      <FormGroupBootstrap
                        name="allergie"
                        type="select-multiple"
                        choices={props.allergie}
                        displayChoice={(all: Allergia) => all.nome}
                        disabled={!deve_accettare_posto}
                        help_text="Tieni premuto Ctrl per selezionare più di uno."
                      />
                    }
                  </>}
                {old?.stato_ammissione === "pts" && !!old.orario_orale &&
                  <h5>Data esame orale: {nice_date(old.orario_orale)} (orario locale del tuo PC)</h5>
                }

                <FormGroupBootstrap
                  name="stage"
                  type="select"
                  choices={first_step ? stages_validi : stages}
                  displayChoice={displayStage}
                  help_text="Lo stage a cui ti stai iscrivendo"
                  disabled={!first_step}
                />
                <FormGroupBootstrap
                  name="persona"
                  type="select"
                  choices={persone}
                  displayChoice={displayPersona}
                  help_text="La persona che vuoi iscrivere."
                  extra_append={first_step && <Link to="/persona-new/" className="btn btn-success" type="button"><i className="fa fa-plus" /></Link>}
                  disabled={!first_step}
                />
                <FormGroupBootstrap
                  name="classe_frequentata"
                  type="select"
                  choices={CLASSI}
                  help_text="Gli studenti del liceo classico indichino l'anno di corso e non l'anno del ginnasio."
                  disabled={!first_step}
                />
                <FormGroupBootstrap
                  name="partecipazione_sigillo"
                  displayName="Partecipazione a Sigillo"
                  type="checkbox"
                  help_text="Hai partecipato alla scuola estiva ufficiale del Gruppo Olimpiadi a Sigillo?"
                  disabled={!first_step}
                />
                <FormGroupBootstrap
                  name="ammissione_fase_regionale_passata"
                  type="checkbox"
                  help_text="Hai partecipato alla fase regionale delle Olimpiadi della Fisica nell'anno scolastico passato?"
                  disabled={!first_step}
                />
                <FormGroupBootstrap
                  name="partecipazione_senigallia"
                  displayName="Partecipazione Senigallia"
                  type="select"
                  help_text="Hai partecipato alla finale Nazionale delle Olimpiadi della Fisica tenutasi a Senigallia nell'anno precedente? Se sì, che medaglia hai ottenuto?"
                  choices={MEDAGLIE_SENIGALLIA}
                  disabled={!first_step}

                />
                <FormGroupBootstrap
                  name="best_precedente"
                  type="textarea"
                  displayName="Risultati precedenti"
                  help_text="Hai partecipato alle Olimpiadi della Fisica anche prima dell'anno precedente? Se sì, qual è il miglior risultato che hai ottenuto?"
                  readOnly={!first_step}
                />
                <FormGroupBootstrap
                  name="varie"
                  type="textarea"
                  displayName="Varie ed eventuali"
                  help_text="Qualsiasi risultato degno di nota che hai ottenuto a delle Olimpiadi scientifiche o qualsiasi cosa ritieni possa essere utile al fine della nostra valutazione."
                  readOnly={!first_step}
                />
                {first_step &&
                  <FormGroupBootstrap
                    name="liberatorie"
                    type="file"
                    help_text="Tutte le liberatorie richieste per l'iscrizione in un unico file in formato PDF."
                  />
                }
                {!!(old?.liberatorie) &&
                  <a href={old.liberatorie_link as string}>
                    <button className="btn btn-info mx-2" type="button">
                      <i className="fa fa-file" /> Liberatorie
                    </button>
                  </a>
                }
                {!!(old?.soluzioni_test_ammissione) &&
                  <a href={old.soluzioni_test_ammissione_link as string}>
                    <button className="btn btn-info mx-2" type="button">
                      <i className="fa fa-file" /> Test ammissione
                    </button>
                  </a>
                }
                {!!(old?.correzioni_test_ammissione) &&
                  <a href={old.correzioni_test_ammissione_link as string}>
                    <button className="btn btn-info mx-2" type="button">
                      <i className="fa fa-file" /> Correzioni test ammissione
                    </button>
                  </a>
                }

                <br />
                <br />
                {!!selected_stage?.pretest && !showPretest &&
                  <button className="btn btn-success mx-2" type="button" onClick={() => setShowPretest(!showPretest)}>
                    <i className="fa fa-pencil mr-1" />
                    {"Mostra PreTest"}
                  </button>
                }
                {(showPretest && !!stage_id) && <QuizPreTest stage={stage} setError={setError} />}

                <br />
                <ErrorBlockGeneric error={error} />
                {show_buttons &&
                  <div className="d-flex justify-content-end">
                    <ConfirmedButton
                      type="warning"
                      onSubmit={handleReset}>
                      Reset
                    </ConfirmedButton>
                    <ConfirmedButton
                      type="success"
                      onSubmit={handleSubmit}
                      disabled={isSubmitting}
                    >
                      Conferma
                    </ConfirmedButton>
                  </div>
                }
              </Form>
            </>
          );
        }}
      </Formik>
    </div>
  )
}


export default IscrizioneStageForm;
